const initGSAPWidgets = () => {
    const generateScriptsGSAP = new Promise((resolve) => {
        function appendScript(src) {
            return new Promise((resolve) => {
                const script = document.createElement("script");
                script.src = src;
                script.onload = resolve;
                document.body.appendChild(script);
            });
        }
        // Check if GSAP and ScrollTrigger are already loaded before appending
        // @ts-ignore
        const gsapLoaded = typeof gsap !== "undefined";
        // @ts-ignore
        const scrollTriggerLoaded = typeof ScrollTrigger !== "undefined";
        const scriptsToLoad = [];
        if (!gsapLoaded) {
            scriptsToLoad.push("https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.2/gsap.min.js");
        }
        if (!scrollTriggerLoaded) {
            scriptsToLoad.push("https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.2/ScrollTrigger.min.js");
        }
        if (scriptsToLoad.length === 0) {
            // Both scripts are already loaded, no need to append
            resolve(null);
        }
        else {
            // Load and append the required scripts
            Promise.all(scriptsToLoad.map(appendScript)).then(resolve);
        }
    });
    generateScriptsGSAP.then(() => {
        const animationVideoAlternativeWidgetList = document.querySelectorAll(".animation-widget");
        if (animationVideoAlternativeWidgetList && animationVideoAlternativeWidgetList.length > 0) {
            animationVideoAlternativeWidgetList.forEach((animationWidgetContainer) => {
                const widgetType = animationWidgetContainer.getAttribute("widget_type");
                if (widgetType == 'scroll-animation') {
                    const canvasContainer = animationWidgetContainer.querySelector(".canvas-container");
                    const canvasContainerId = "#" + canvasContainer.getAttribute("id");
                    const canvas = canvasContainer.querySelector("canvas");
                    const context = canvas.getContext("2d");
                    const urls = JSON.parse(canvas.getAttribute("urls"));
                    canvas.width = 1158;
                    canvas.height = 770;
                    const images = [];
                    const airpods = {
                        frame: 0
                    };
                    for (let i = 0; i < urls.length; i++) {
                        const img = new Image();
                        img.src = urls[i];
                        images.push(img);
                    }
                    gsap.to(airpods, {
                        frame: urls.length - 1,
                        snap: "frame",
                        ease: "none",
                        scrollTrigger: {
                            trigger: canvasContainerId,
                            start: "top top",
                            end: "+=3500",
                            markers: true,
                            pin: true,
                            scrub: 0.5
                        },
                        onUpdate: render // use animation onUpdate instead of scrollTrigger's onUpdate
                    });
                    images[0].onload = render;
                    function render() {
                        context.clearRect(0, 0, canvas.width, canvas.height);
                        context.drawImage(images[airpods.frame], 0, 0, 1158, 1158 * images[airpods.frame].height / images[airpods.frame].width);
                    }
                }
                if (widgetType == 'slider-animation') {
                    const gallery = animationWidgetContainer.querySelector(".gallery-container");
                    if (window.innerWidth > 1180) {
                        const sections = gsap.utils.toArray("[data-gsap-gallery]");
                        const sectionCount = sections.length;
                        const xPercentValue = -((sectionCount - 6) * 10 + 70);
                        // @ts-ignore
                        const scrollTween = gsap.to(sections, {
                            xPercent: xPercentValue * (sections.length - 1),
                            ease: "none",
                            scrollTrigger: {
                                trigger: gallery,
                                pin: true,
                                scrub: 0.1,
                                end: "+=3000",
                            },
                        });
                    }
                    else {
                        let config = new CarouselConfig();
                        const responsiveCarousel = new ResponsiveCarousel();
                        setTimeout(() => {
                            config = new CarouselConfig();
                            config.sliderSelector = ".gallery-container";
                            config.cellAlign = CellAlign.left;
                            config.contain = true;
                            config.showDots = false;
                            const createdGalleryArray = responsiveCarousel.initCarousel(config);
                        }, 200);
                    }
                }
            });
        }
    });
};
